export default __webpack_public_path__ + "static/media/cc_dkGray.48d965a4.jpg";